import { Fragment, FunctionComponent, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";

import { Tooltip } from "primereact/tooltip";

import { TooltipWrapper } from "../../../../../components/Shared/Components/TooltipWrapper/TooltipWrapper";
import { ICustomKnowledgeBaseReadChatbot } from "../../../../../stores";
import { KnowledgeBaseTypeIcon } from "../KnowledgeBaseTypeIcon/KnowledgeBaseTypeIcon";

interface IKnowledgeBaseDropdownItemProps {
  item: ICustomKnowledgeBaseReadChatbot;
  translatedKnowledgeBaseName: (knowledgeBase: ICustomKnowledgeBaseReadChatbot) => string;
}

const RawKnowledgeBaseDropdownItem: FunctionComponent<IKnowledgeBaseDropdownItemProps> = (
  props: IKnowledgeBaseDropdownItemProps,
) => {
  const dropdownItemRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<Tooltip>(null);

  const [typeIconTooltipVisible, setTypeIconTooltipVisible] = useState<boolean>(false);

  useEffect(() => {
    if (typeIconTooltipVisible && tooltipRef?.current?.props.disabled) {
      tooltipRef.current?.hide();
    }
  }, [typeIconTooltipVisible]);

  return (
    <Fragment>
      <TooltipWrapper
        targetRef={dropdownItemRef}
        tooltipRef={tooltipRef}
        content={props.item.tooltip}
        disabled={!props.item.tooltip?.length || typeIconTooltipVisible}
        position="right"
      />

      <div className="knowledge-base-dropdown-item" ref={dropdownItemRef}>
        <div className="dropdown-item-column">
          <span className="dropdown-tooltip-item">{props.translatedKnowledgeBaseName(props.item)}</span>
        </div>

        {!!props.item.id && (
          <div className="dropdown-item-column">
            <KnowledgeBaseTypeIcon
              isSpoKnowledgebase={props.item.isSpoKnowledgeBase}
              setIsTooltipVisible={setTypeIconTooltipVisible}
              isActive={false}
            />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export const KnowledgeBaseDropdownItem = observer(RawKnowledgeBaseDropdownItem);
